import { render, staticRenderFns } from "./ConceptsTable.vue?vue&type=template&id=aa2d159c&scoped=true"
import script from "./ConceptsTable.vue?vue&type=script&lang=js"
export * from "./ConceptsTable.vue?vue&type=script&lang=js"
import style0 from "./ConceptsTable.vue?vue&type=style&index=0&id=aa2d159c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa2d159c",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/pages/RoadSinisters/File/Lifting/ConceptsTable.vue
// module id = 1957
// module chunks = 31